import React from 'react';

import WpIcon from 'Wpds/components/icon/WpIcon';
import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import './ConnectCalendarContentArea.scss';

const img = 'https://piprodperformassets.blob.core.windows.net/assets/charma_add_to_calendar.png';

const advantages = [
  'Get reminders to prepare for your 1:1 meetings',
  'Sync workspaces with your calendar events',
  'Access workspaces from your calendar',
];

function ConnectCalendarContentArea() {
  return (
    <div className="ConnectCalendarContentArea p-xl-5 flex-column">
      <CharmaLogo width="180" className="m-5 pb-3" />
      <div className="p-4 d-flex flex-column">
        <img src={img} alt={img} className="ConnectCalendarContentArea__img" />
        <div className="ConnectCalendarContentArea__title mt-4 mb-2">Connect your calendar to:</div>
        {advantages.map(advantage => (
          <div key={advantage} className="d-flex mt-4">
            <div className="mr-2">
              <WpIcon name="check" />
            </div>
            {advantage}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConnectCalendarContentArea;
